@if (hasCloseButton) {
  <button
    mat-icon-button
    aria-label="Close"
    class="close celo-dialog-close celo-dialog-close--floating"
    (click)="closeClick.emit()"
  >
    <mat-icon>close</mat-icon>
  </button>
}

<ng-content select="[image]"></ng-content>

@if (title) {
  <h1
    class="title pb-16"
    [style.fontSize]="titleFontSize"
    [textContent]="title"
  ></h1>
}

<p class="pb-20 content">
  <ng-content select="[content]"></ng-content>
</p>

<div class="buttons flex flex-col w-full g-10px">
  @if (primaryButtonHref) {
    <a
      mat-button
      class="celo-primary-button uppercase"
      [href]="primaryButtonHref"
      [disabled]="isPrimaryButtonLoading"
    >
      @if (isPrimaryButtonLoading) {
        <app-basic-spinner [diameter]="20"></app-basic-spinner>
      }
      @if (!isPrimaryButtonLoading) {
        {{ primaryButtonText }}
      }
    </a>
  } @else {
    <button
      mat-button
      class="celo-primary-button uppercase"
      (click)="primaryClick.emit()"
      [disabled]="isPrimaryButtonLoading"
    >
      @if (isPrimaryButtonLoading) {
        <app-basic-spinner [diameter]="20"></app-basic-spinner>
      }
      @if (!isPrimaryButtonLoading) {
        {{ primaryButtonText }}
      }
    </button>
  }

  @if (secondaryButtonText) {
    <button
      mat-button
      [ngClass]="{
        'celo-tertiary-button': !isPrimaryButtonLoading,
        'celo-disabled': isPrimaryButtonLoading,
      }"
      (click)="secondaryClick.emit()"
      [textContent]="secondaryButtonText"
      [disabled]="isPrimaryButtonLoading"
    ></button>
  }
</div>

<p class="disclaimer">
  <ng-content select="[disclaimer]"></ng-content>
</p>
